<template>
  <span class="caring-button" @click="onClick()" :style="{'font-size': size + 'px'}">
    <slot></slot>
  </span>
</template>

<script>
export default {
  name: 'caring-button',
  props: {
    size: {
      type: Number,
      default: 14,
    },
  },
  methods: {
    onClick() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="less">
  @import '../../styles/common.less';

  .caring-button {
    color: @primary-color;
    cursor: pointer;
    transition: all .4s ease-in-out;
  }

  .caring-button + .caring-button {
    margin-left: 15px;
  }

  .caring-button:hover {
    opacity: .6;
  }
</style>
